import { autocompleteClasses, Box } from "@mui/material";

export function AutocompletePopperSlot({
  anchorEl: _anchorEl,
  disablePortal: _disablePortal,
  open: _open,
  ...other
}: {
  anchorEl?: any;
  disablePortal?: boolean;
  open: boolean;
}) {
  return (
    <Box
      {...other}
      sx={{
        [`& .${autocompleteClasses.paper}`]: {
          boxShadow: "none",
          border: "none",
          margin: 0,
          borderRadius: 0,
        },
        [`& .${autocompleteClasses.listbox}`]: {
          padding: 0,
          maxHeight: "300px",
          [`& .${autocompleteClasses.option}`]: {
            minHeight: "auto",
            alignItems: "flex-start",
            borderRadius: 0,
            [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]:
              {
                backgroundColor: "action.hover",
              },
          },
        },
        [`&.${autocompleteClasses.popperDisablePortal}`]: {
          position: "relative",
        },
      }}
    />
  );
}
